/* MYOP Hero slideshow controller (scroll-snap based). */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function Hero(root) {
    this.root = root;
    this.viewport = root.querySelector('.myop-hero__viewport');
    this.slides = Array.prototype.slice.call(root.querySelectorAll('.myop-hero__slide'));
    this.dots = Array.prototype.slice.call(root.querySelectorAll('.myop-hero__dot'));
    this.controls = root.querySelector('.myop-hero__controls');
    this.index = 0;
    this.count = this.slides.length;
    this.autoplay = root.dataset.autoplay === 'true' && !reduce;
    this.speed = (parseFloat(root.dataset.autoplaySpeed) || 6) * 1000;
    this.timer = null;
    if (this.count > 1) this.bind();
  }

  Hero.prototype.go = function (i) {
    this.index = (i + this.count) % this.count;
    var slide = this.slides[this.index];
    if (!slide) return;
    var vp = this.viewport;
    var vpRect = vp.getBoundingClientRect();
    var slideRect = slide.getBoundingClientRect();
    // Center the active slide within the viewport (symmetric peek on both sides).
    var slideCenter = (slideRect.left - vpRect.left) + vp.scrollLeft + slideRect.width / 2;
    var target = slideCenter - vp.clientWidth / 2;
    vp.scrollTo({ left: target, behavior: reduce ? 'auto' : 'smooth' });
    this.markActive();
    this.syncColor(slide);
  };
  Hero.prototype.markActive = function () {
    this.dots.forEach(function (d, di) { d.setAttribute('aria-current', di === this.index ? 'true' : 'false'); }, this);
    this.slides.forEach(function (s, si) {
      // Re-trigger the "settle into frame" animation each time a slide becomes active.
      if (si === this.index) {
        s.classList.remove('is-active');
        void s.offsetWidth; // force reflow so the transition restarts
        s.classList.add('is-active');
      } else {
        s.classList.remove('is-active');
      }
    }, this);
  };
  Hero.prototype.nearestIndex = function () {
    var vpRect = this.viewport.getBoundingClientRect();
    var vpCenter = vpRect.left + vpRect.width / 2;
    var nearest = 0, best = Infinity;
    this.slides.forEach(function (s, si) {
      var r = s.getBoundingClientRect();
      var c = r.left + r.width / 2;
      var d = Math.abs(c - vpCenter);
      if (d < best) { best = d; nearest = si; }
    });
    return nearest;
  };
  Hero.prototype.syncColor = function (slide) {
    if (this.controls && slide && slide.dataset.controlsColor) {
      this.controls.style.setProperty('--hero-controls-color', slide.dataset.controlsColor);
    }
  };
  Hero.prototype.next = function () { this.go(this.index + 1); };
  Hero.prototype.prev = function () { this.go(this.index - 1); };

  Hero.prototype.start = function () {
    if (!this.autoplay || this.timer) return;
    var self = this;
    this.timer = setInterval(function () { self.next(); }, this.speed);
  };
  Hero.prototype.stop = function () { clearInterval(this.timer); this.timer = null; };

  Hero.prototype.bind = function () {
    var self = this;

    this.dots.forEach(function (dot) {
      dot.addEventListener('click', function () { self.stop(); self.go(parseInt(dot.dataset.goto, 10)); self.start(); });
    });

    var nextBtn = this.root.querySelector('[data-myop-next]');
    if (nextBtn) nextBtn.addEventListener('click', function () { self.stop(); self.next(); self.start(); });

    var prevBtn = this.root.querySelector('[data-myop-prev]');
    if (prevBtn) prevBtn.addEventListener('click', function () { self.stop(); self.prev(); self.start(); });

    var pauseBtn = this.root.querySelector('[data-myop-pause]');
    if (pauseBtn) {
      pauseBtn.addEventListener('click', function () {
        if (self.timer) {
          self.stop();
          pauseBtn.setAttribute('aria-pressed', 'true');
          pauseBtn.setAttribute('aria-label', 'Play slideshow');
        } else {
          self.start();
          pauseBtn.setAttribute('aria-pressed', 'false');
          pauseBtn.setAttribute('aria-label', 'Pause slideshow');
        }
      });
    }

    // Keep active dot in sync when user scroll/swipes.
    var scrollTO;
    this.viewport.addEventListener('scroll', function () {
      clearTimeout(scrollTO);
      scrollTO = setTimeout(function () {
        var nearest = self.nearestIndex();
        if (nearest !== self.index) {
          self.index = nearest;
          self.markActive();
          self.syncColor(self.slides[nearest]);
        }
      }, 120);
    }, { passive: true });

    // Pause on hover / when tab hidden.
    this.root.addEventListener('mouseenter', function () { self.stop(); });
    this.root.addEventListener('mouseleave', function () { self.start(); });
    document.addEventListener('visibilitychange', function () { document.hidden ? self.stop() : self.start(); });

    this.markActive(); // animate the first slide into its frame on load
    this.start();
  };

  function init(scope) {
    (scope || document).querySelectorAll('.myop-hero').forEach(function (el) {
      if (el.dataset.myopHeroInit === 'true') return;
      el.dataset.myopHeroInit = 'true';
      new Hero(el);
    });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', function () { init(); });
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
